<template>
  <div>
    <Logo :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div class="flex-grid">
        <div class="flex">
          <div class="item grid-2">
            <div id="main_area">
              <!-- ▼頁籤-->
              <ul class="menu2">
                <li :class="{ on: view == 'Notice' }">
                  <a @click="btnChangeView('Notice')"
                    ><img src="@/assets/img/icon_notes.png" />公告</a
                  >
                </li>
                <li :class="{ on: view == 'Download' }">
                  <a @click="btnChangeView('Download')"
                    ><img src="@/assets/img/icon_download.png" />下載</a
                  >
                </li>
                <li :class="{ on: view == 'Phone' }">
                  <a @click="btnChangeView('Phone')"
                    ><img src="@/assets/img/icon_qa.png" />客服<span
                      >電話</span
                    ></a
                  >
                </li>
              </ul>
              <!-- ▲頁籤 -->
              <div class="information">
                <div class="flex-container2">
                  <div class="flex2">
                    <div class="item2">
                      <div class="table_scroll2">
                        <!--  最新消息-->
                        <table
                          v-show="view == 'Notice'"
                          width="1060"
                          class="itable"
                        >
                          <tr
                            v-for="(data, index) in dropDownList.Notices"
                            :key="index"
                            @click="btnNoticeDetail(data)"
                            style="cursor: pointer"
                          >
                            <td class="f_left">
                              {{ data.title }}
                            </td>
                            <td width="80">{{ data.postDate }}</td>
                          </tr>
                        </table>
                        <!-- 下載 -->
                         <table
                          v-show="view == 'Download'"
                          width="1060"
                          class="itable"
                        >
                          <tr
                            v-for="(data, index) in dropDownList.downloads"
                            :key="index"
                            @click="btnNoticeDetail(data)"
                            style="cursor: pointer"
                          >
                            <td class="f_left">
                              {{ data.title }}
                            </td>
                          </tr>
                        </table>
                        <!-- <table
                          v-show="view == 'Download'"
                          width="1060"
                          class="itable"
                        >
                          <tr>
                            <td class="f_left">
                              <a
                                href="/PdpsCli/download/法務部公職人員財產申報系統-後台管理系統使用者帳號申請異動單.doc"
                                download
                                >法務部公職人員財產申報系統-後台管理系統使用者帳號申請異動單</a
                              >
                            </td>
                          </tr>
                          <tr>
                            <td class="f_left">
                              <a
                                href="/PdpsCli/download/法務部公職人員財產申報系統操作手冊_申報人端.pdf"
                                download
                                >法務部公職人員財產申報系統操作手冊_申報人端</a
                              >
                            </td>
                          </tr>
                          <tr>
                            <td class="f_left">
                              <a
                                href="/PdpsCli/download/法務部公職人員財產申報系統操作手冊_後台管理端.pdf"
                                download
                                >法務部公職人員財產申報系統操作手冊_後臺管理端</a
                              >
                            </td>
                          </tr>
                        </table> -->
                        <!-- 常見問題 -->
                        <table
                          width="1060"
                          class="itable"
                          v-show="view == 'Phone'"
                        >
                          <tr>
                            <td class="f_left">
                              廉政署服務專線：(02)2314-1000 (分機 2190 &amp; 2191 &amp; 2255)
                            </td>
                          </tr>
                          <tr>
                            <td class="f_left">廉政署服務傳真：(02)2381-6077</td>
                          </tr>
                          <tr>
                            <td class="f_left">
                              廉政署服務電子郵件信箱：
                              <a href="mailto:aac2190@mail.moj.gov.tw">aac2190@mail.moj.gov.tw</a>、
                              <a href="mailto:aac2191@mail.moj.gov.tw">aac2191@mail.moj.gov.tw</a>、
                              <a href="mailto:aac2255@mail.moj.gov.tw">aac2255@mail.moj.gov.tw</a>
                            </td>
                          </tr>
                          <tr>
                            <td class="f_left">客服服務時間：09:00-18:00</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form action="">
            <div class="item grid-3">
              <div id="wrapper">
                <div class="loginBox">
                  <h1>後台管理登入</h1>
                  <div class="loginTxt">
                    <label for="username" class="uname"></label>
                    <div class="login_link">
                      <ul></ul>
                    </div>
                  </div>
                  <div class="enter">
                    <input placeholder="帳號" type="text" v-model="form.id" />
                    <input placeholder="密碼" type="password" v-model="form.idtoken" />
                    <div style="color: red" v-show="CAPS">大寫已鎖定</div>
                    <Captcha ref="Captcha" />
                    <a href="javascript:playmusic()">
                      <i style="font-size: 19px" class="fa fa-volume-up"></i>
                    </a>
                    <!-- <audio id="audio1" src="../imageFileValidate.wav"></audio> -->
                  </div>
                  <div class="loginButton">
                    <input
                      type="button"
                      class="btn_blue3"
                      value="登 入"
                      @click="btnLogin()"
                    />
                    <input
                      type="button"
                      class="btn_blue3"
                      style="margin-left: 10px"
                      value="重 填"
                      @click="btnClear()"
                    />
                  </div>
                  <div class="loginTxt2">
                    <a @click="btnAddAcount()">密碼申請</a>
                    <a style="margin-left: 20px" @click="btnForgetPwd()"
                      >忘記密碼</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <PdisFooter />

    <Notice
      v-model="Notice.show"
      :title="Notice.grid.title"
      :modalStyle="{ 'max-width': '1200px' }"
      :ServiceUnit="pageData.ServiceUnit"
    >
      <div class="information">
        <div class="flex-container2">
          <div class="flex2">
            <div class="item2 p4">
              <!--  最新消息-->
              <div class="table_scroll2">
                <div id="two_column">
                  <dl>
                    <h3>公告日期：</h3>
                    <dd>
                      <p class="txt_01">
                        {{ Notice.grid.postDate }}
                      </p>
                    </dd>
                    <h3>標題：</h3>
                    <dd>
                      <p class="txt_01">{{ Notice.grid.title }}</p>
                    </dd>
                    <h3>內容：</h3>
                    <dd>
                      <p v-html="Notice.grid.content"></p>
                    </dd>
                    <h3>附件檔案：</h3>
                    <dd v-for="(data, index) in Notice.grid.file" :key="index">
                      <a
                        :href="
                          data.attR_STRING
                            ? 'data:' + data.attR_TYPE + ';base64,' + data.attR_STRING
                            : '#'
                        "
                        :download="data.attR_NAME"
                      >
                        {{ data.attR_NAME }}
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Notice>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import Logo from "@/components/Common/Logo.vue";
import Captcha from "@/components/Common/Captcha.vue";
import {
  BackstageApiLogin,
  GetNotice,
  GetDownload,
  GetNoticeDetail,
} from "@/service/api.js";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import Timeout from  "@//components/Common/Timeout.vue";
export default {
  name: "Login",
  data: function () {
    return {
      pageData: {
        ServiceUnit: "PDIS",
        isForceLoginOut: false,
      },
      view: "Notice",
      dropDownList: {
        Notices: [],
        downloads: [],
      },
      form: {
        id: "",
        idtoken: "",
      },
      grid: {},
      Notice: {
        show: false,
        title: "",
        grid: [],
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      CAPS: false,
    };
  },
  components: {
    Logo,
    Captcha,
    PdisFooter,
    Notice: VueModal,
    Alert: VueModal,
  },
  mounted() {
    const self = this;
    document.addEventListener('keydown', function( event ) {
      self.CAPS = event.getModifierState && event.getModifierState('CapsLock');
    });
    document.addEventListener('keyup', function( event ) {
      self.CAPS = event.getModifierState && event.getModifierState('CapsLock');
    });
  },
  methods: {
    verification: function () {
      const self = this;
      let errorMsg = [];
      let CaptchaComponent = self.$refs.Captcha;
      if (self.form.id === "") {
        errorMsg.push("請輸入帳號");
      }
      if (self.form.idtoken === "") {
        errorMsg.push("請輸入密碼");
      }
      if (CaptchaComponent.newRow.captcha === "") {
        errorMsg.push("驗證碼不可為空");
      } else {
        if (CaptchaComponent.newRow.captcha != CaptchaComponent.captchaTxt) {
          errorMsg.push("驗證碼不正確!");
        }
      }
      if (errorMsg.length > 0) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = errorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
          self.btnClear();
        };
        return false;
      } else {
        return true;
      }
    },
    btnLogin: function () {
      const self = this;
      if (!self.verification()) return;
      let postData = {
        serviceUnit: "PDIS",
        id: self.form.id,
        idtoken: self.form.idtoken,
      };
      BackstageApiLogin(postData).then((rData) => {
        if (rData.result) {
          sessionStorage.setItem(
            "LoginInfo",
            JSON.stringify(rData.returnObject[0])
          );
          sessionStorage.removeItem("Session_GovCode");
          if (rData.returnObject[0].pwdFlag == "Y") {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["使用系統預設密碼登入，須更新密碼才能使用本系統"];
            self.Alert.BtnConfirm = () => {
              this.$router.push({ path: "/BackStage/PDIS/S302" });
            };
          } else {
            //每三秒（3000 毫秒）
            this.$router.push({ path: "/BackStage/PDIS/P102" });
            Timeout.methods.setDefaultTime();
            // setTimeout(() => {
            //   console.log("準備登出系統");
            // }, 1000);
            // setTimeout(() => {
            //   alert("已登出系統");
            //   sessionStorage.removeItem("LoginInfo");
            //   sessionStorage.removeItem("Session_GovCode");
            //   this.$router.push({ path: "/BackStage/PDIS/Login" });
            // }, 50000);
          }
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.btnClear();
            if (rData.returnObject && rData.returnObject.isPasswordExpired) {
              self.$router.push({ path: "/BackStage/PDIS/S302" });
            }
          };
        }
      });
    },
    btnClear: function () {
      this.form = {
        id: "",
        idtoken: "",
      };
      this.$refs.Captcha.writeAuthCode();
      this.$refs.Captcha.newRow.captcha = "";
    },
    btnAddAcount: function () {
      this.$router.push({ path: "/BackStage/PDIS/S306" });
    },
    btnForgetPwd: function () {
      const self = this;
      this.$router.push({ path: "/BackStage/PDIS/S303" });
    },
    btnChangeView: function (data) {
      const self = this;
      switch (data) {
        case "Notice":
          self.view = "Notice";
          break;
        case "Download":
          self.view = "Download";
          break;
        case "Phone":
          self.view = "Phone";
          break;
      }
    },
    //取得公告
    getNoticeData: function () {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postNode: "0",
      };
      GetNotice(postData).then((returnData) => {
        self.dropDownList.Notices = returnData.returnObject.notices;
        self.dropDownList.Notices.forEach(
          (x) => (x.postDate = self.$moment(x.posT_DATE).format("YYYY/MM/DD"))
        );
      });
      //取得下載
      postData.postNode = "9";
      GetDownload(postData).then((returnData) => {
        self.dropDownList.downloads = returnData.returnObject.notices;
      });
    },
    btnNoticeDetail: function (data) {
      const self = this;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        postSeq: data.posT_SEQ,
      };
      GetNoticeDetail(postData).then((returnData) => {
        self.Notice.grid = returnData.returnObject.noticeDetails[0];
        self.Notice.grid.postDate = self
          .$moment(self.Notice.grid.posT_DATE)
          .format("YYYY/MM/DD HH:mm:ss");
        self.Notice.show = true;
      });
    },
  },
  created() {
    this.getNoticeData();
    sessionStorage.removeItem("LoginInfo");
  },
};
</script>


